import * as angular from 'angular';
import * as template from './template.html';
import './styling.scss';

import {
    getFormattedBelongingsCoverageAmount,
    getReplacementCostCoverageDisplay
} from 'common/source/utilities/policyInfoDisplay';
import { CurrentUserService } from 'services/currentUser';
import { isDp3Policy } from 'common/source/utilities/policyInfoHelper';

const module = angular.module('coverage-belongings-section', []);

interface CoverageBelongingsSectionController extends angular.IStrictController {
    title: string;
    description: string;
    icon: string;
    coverages: Array<NameAndValue>;
}

module.component('coverageBelongingsSection', {
    template: template,
    controller: function(
        this: CoverageBelongingsSectionController,
        currentUserService: CurrentUserService,
        $stateParams: PolicyStateParams
    ) {
        this.$onInit = () => {
            this.title = 'Belongings';
            this.icon = 'laptop';
            const policyIndex = $stateParams.policyIndex;

            currentUserService.getCustomerPolicyInfoByIndex(policyIndex).then((policyInfo) => {
                if (isDp3Policy(policyInfo)) {
                    this.description = `This is the insurance that covers some of the contents 
                                        inside your property that you own (such as major appliances 
                                        like refrigerators, washing machines, etc.). When claims 
                                        are made for covered items, your insurance pays the 
                                        depreciated value of the belongings. The amount of coverage 
                                        may vary depending on type of item and the specific type of 
                                        peril (e.g. fire damage).`;
                    this.coverages = [
                        {
                            name: 'Household Furnishings',
                            value: getFormattedBelongingsCoverageAmount(policyInfo)
                        }
                    ];
                } else {
                    this.description = `This is the insurance that covers some of your personal 
                                        property both inside and in certain instances, outside 
                                        of your home. When claims are made for covered items, 
                                        your insurance pays either the replacement value or 
                                        depreciated value of the belongings, depending on your 
                                        selected plan. The amount of coverage may vary depending 
                                        on type of item, location of item (in vs. out of home) and
                                        the specific type of peril (e.g. fire damage).`;
                    this.coverages = [
                        {
                            name: 'Personal Property',
                            value: getFormattedBelongingsCoverageAmount(policyInfo)
                        },
                        {
                            name: 'Replacement Cost',
                            value: getReplacementCostCoverageDisplay(policyInfo)
                        }
                    ];
                }

                // TODO: Add SPP items.
            });
        };
    }
});

export { module };
